import { appContext } from "../../../AppContext";
import { IbssComponent } from "../../Core/BaseComponent/IbssComponent"
import { PasswordDialog } from "./PasswordDialog";
import { DiagnosticsDialog } from "./DiagnosticsDialog";
import { JSX } from "react";
import { SerendieSymbol } from "@serendie/symbols";
import { List } from "@iconics/components";
import { ListItem } from "@iconics/components";
import { Button, LanguageDialog, ThemeDialog, ThemeId, Typography } from "@iconics/components";

export default class Menu extends IbssComponent<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state = {
            themeId: appContext().state.themeId,
            showMenu: false,
            showDiagnosticsDialog: false,
            showPasswordDialog: false,
            showThemeDialog: false,
            showLanguageDialog: false,
        };
    }

    public componentDidMount(): void
    {
        appContext().state.autoMap(this, i => ({ themeId: i.themeId }));
    }

    private handleThemeChange(themeId: ThemeId): void
    {
        document.documentElement.setAttribute("data-panda-theme", themeId);
        appContext().state.set({ themeId: themeId });
        appContext().localStorageProvider.setTheme(themeId);
    }

    public render(): JSX.Element
    {
        const { labels, localStorageProvider } = appContext();
        const userDetails = localStorageProvider.getUserDetails();

        return (
            <>
                <Button
                    className="header__account-menu"
                    onClick={() => this.setState({ showMenu: !this.state.showMenu })}
                    aria-label='profile menu'
                    aria-expanded={this.state.showMenu}
                    styleType='ghost'
                >
                    <SerendieSymbol name='user' className="header__account-menu-user" />
                    <span className="header__account-menu-name">
                        <Typography role="label" size="extraLarge" inline>{userDetails.displayName}</Typography>
                    </span>
                    <SerendieSymbol name={this.state.showMenu ? 'chevron-up' : 'chevron-down'} className="header__account-menu-expand" />
                </Button>
                {this.state.showMenu && (
                    <List
                        className="header__options"
                        id="myDropdown"
                        onMouseLeave={() => this.setState({ showMenu: !this.state.showMenu })}
                    >
                        <ListItem
                            title={labels.Platform_UserMenu_ChangeTheme}
                            leftIcon={<SerendieSymbol name='moon' />}
                            className="header__option"
                            onClick={() => this.setState({ showThemeDialog: true })}
                        />
                        <ListItem
                            title={labels.Platform_UserMenu_ChangeLanguage}
                            leftIcon={<SerendieSymbol name='type' />}
                            className="header__option"
                            onClick={() => this.setState({ showLanguageDialog: true })}
                        />
                        {userDetails.userType === "Native" &&
                            <ListItem
                                title={labels.Platform_UserMenu_ChangePassword}
                                leftIcon={<SerendieSymbol name='lock' />}
                                className="header__option"
                                onClick={() => this.setState({ showPasswordDialog: true })}
                            />
                        }

                        <ListItem
                            title={labels.Platform_UserMenu_Diagnostics}
                            leftIcon={<SerendieSymbol name='information' />}
                            className="header__option"
                            onClick={() => this.setState({ showDiagnosticsDialog: true })}
                        />
                        <ListItem
                            title={labels.Platform_UserMenu_Logout}
                            leftIcon={<SerendieSymbol name='logout' />}
                            className="header__option"
                            onClick={() => appContext().authentication.logOut()}
                        />
                    </List>
                )}

                <DiagnosticsDialog
                    open={this.state.showDiagnosticsDialog}
                    onClose={() => this.setState({ showDiagnosticsDialog: false })}
                />

                <PasswordDialog
                    open={this.state.showPasswordDialog}
                    onClose={() => this.setState({ showPasswordDialog: false })}
                />

                <LanguageDialog
                    open={this.state.showLanguageDialog}
                    onClose={() => this.setState({ showLanguageDialog: false })}
                    getCurrentLanguage={() => Promise.resolve(appContext().language.current)}
                    localisation={appContext().localisation}
                />

                <ThemeDialog
                    open={this.state.showThemeDialog}
                    themeId={this.state.themeId}
                    onChange={(themeId: ThemeId) => this.handleThemeChange(themeId)}
                    onClose={() => this.setState({ showThemeDialog: false })}
                    title={labels.Platform_ThemeMenu_Title}
                    subTitle={labels.Platform_ThemeMenu_SubTitle}
                    themeInputLabel={labels.Platform_ThemeMenu_Theme}
                    konjoLabel={labels.Platform_ThemeMenu_Konjo}
                    asagiLabel={labels.Platform_ThemeMenu_Asagi}
                    kurikawaLabel={labels.Platform_ThemeMenu_Kurikawa}
                    sumireLabel={labels.Platform_ThemeMenu_Sumire}
                    tsutsujiLabel={labels.Platform_ThemeMenu_Tsutsji}
                    darkLabel={labels.Platform_ThemeMenu_Dark}
                    highContrastLabel={labels.Platform_ThemeMenu_HighContrast}
                    saveButtonLabel={labels.Platform_CommonAction_Save}
                    cancelButtonLabel={labels.Platform_CommonAction_Cancel}
                />
            </>
        );
    }
}

export interface IProps { }

export interface IState
{
    themeId: ThemeId;
    showMenu: boolean;
    showDiagnosticsDialog: boolean;
    showPasswordDialog: boolean;
    showThemeDialog: boolean;
    showLanguageDialog: boolean;
}
